import { AfterViewInit, Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ConfirmationDialogContext, ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';

@Component({
  selector: 'confirmation-dialog',
  imports: [CommonModule],
  templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialogComponent implements AfterViewInit, OnDestroy {
  @ViewChild('content') private content!: TemplateRef<unknown>;

  ctx: ConfirmationDialogContext | null = null;

  private modalRef?: NgbModalRef;
  private readonly subscription = new Subscription();

  constructor(
    private confirmationDialogService: ConfirmationDialogService,
    private modalService: NgbModal
  ) { }

  ngAfterViewInit(): void {
    this.subscription.add(
      this.confirmationDialogService.state$.subscribe(state => {
        if (state.isOpen && state.context) {
          this.ctx = state.context;
          this.openModal();
        } else {
          this.closeModal();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.closeModal();
  }

  onConfirm(): void {
    this.ctx?.onConfirm();
    this.confirmationDialogService.close();
  }

  onCancel(): void {
    this.ctx?.onCancel?.();
    this.confirmationDialogService.close();
  }

  private openModal(): void {
    if (this.modalRef) {
      return;
    }

    this.modalRef = this.modalService.open(this.content, {
      centered: true,
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });

    // Chiusura con ESC: si comporta come un "No".
    this.modalRef.result.catch(() => {
      this.modalRef = undefined;
      const onCancel = this.ctx?.onCancel;
      this.ctx = null;
      onCancel?.();
      this.confirmationDialogService.close();
    });
  }

  private closeModal(): void {
    this.ctx = null;
    const ref = this.modalRef;
    this.modalRef = undefined;
    ref?.dismiss();
  }
}
